import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { ProductService } from '../../services/product.service';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.css'],
})
export class CreateProductComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  listCategory: { label: string; value: string }[] = [];

  constructor(
    protected _productService: ProductService,
    protected _categoryService: CategoryService,
    protected _injector: Injector
  ) {
    super(_productService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl('', [Validators.required]),
      name: new UntypedFormControl('', [Validators.required]),
      categoryId: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {}

  onShowPopup() {
    if (this.listCategory.length == 0) {
      this.getListCategory();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    this.onReset();

    this.itemDetail.id = 0;
    this.itemDetail.status = 1;
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }
    this.onInsert();
  }

  getListCategory() {
    const model = {
      status: 1
    };
    this._categoryService.getListCategory(model).then(
      (res) => {
        this.listCategory = res?.data.map((x) => ({
          label: `${x.code} - ${x.name}`,
          value: x.id,
        }));
      },
      (err) => {
        this.listCategory = [];
      }
    );
  }

  onInsert() {
    this._productService.create(this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showInsertDataFailed();
        this.submitting = false;
      }
    );
  }
}
